import {selectPlayers, selectPlayersConfirmedSetupPhase} from "../../../redux/reducers/sharedStateReducer/selectors";

export const checkIfAllPlayersConfirmedStartingQuarter = (state) => {
  const players = selectPlayers(state);
  const playersConfirmedSetupPhase = selectPlayersConfirmedSetupPhase(state);

  return players.every(player => {
    return playersConfirmedSetupPhase.includes(player.id);
  });
}